import { v4 } from "uuid";
import { createAuthDialog } from "@/components/auth/auth-dialog/auth-dialog";
import { useInstagramSearch } from "../hooks/useInstagramSearch";

export const requestInstagramSearchAuth = () => {
  createAuthDialog({
    view: "sign-up",
    onSuccess: (data) => {
      useInstagramSearch.setState({
        id: v4(),
        isAuthorized: true,
        isSubscribed: data.subscriptions.search === true,
      });
    },
  });
};

export const isUsername = (value: string) => {
  return /^[a-z0-9._]+$/i.test(value);
};
